import { render } from "./text-overline.vue?vue&type=template&id=2293ace2&scoped=true"
const script = {}

import "./text-overline.vue?vue&type=style&index=0&id=2293ace2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2293ace2"],['__file',"src/views/other/cssfx/components/text-overline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2293ace2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2293ace2', __exports__)) {
    console.log('reload')
    api.reload('2293ace2', __exports__)
  }
  
  module.hot.accept("./text-overline.vue?vue&type=template&id=2293ace2&scoped=true", () => {
    console.log('re-render')
    api.rerender('2293ace2', render)
  })

}


export default __exports__